import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const toSafeText = (value) => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return '';
};

export const AppErrorRendererCard = ({
  field,
  message,
  errorMsg,
  fieldNameMap = {},
  hasFieldErrors,
  dataTestId,
}) => {
  const safeField = toSafeText(field);
  const safeMessage = toSafeText(message) || 'Erro ao processar requisição';
  const safeErrorMessage = toSafeText(errorMsg);
  const safeFieldName = toSafeText(fieldNameMap?.[safeField]) || safeField;

  return (
    <Box
      width={280}
      display="flex"
      alignItems={hasFieldErrors ? 'initial' : 'center'}
      minHeight={70}
      py={hasFieldErrors ? 2 : 0}
      data-testid={dataTestId}
    >
      <Box
        display="flex"
        justifyContent={hasFieldErrors ? 'initial' : 'center'}
        flexDirection="column"
        gap={1}
      >
        {safeFieldName && (
          <Typography variant="body2" color="error.main" fontWeight="bold" textTransform="capitalize">
            {safeFieldName}
          </Typography>
        )}
        <Typography variant="body2" fontWeight="600">
          {safeMessage}
        </Typography>
        {safeErrorMessage &&
          !/^[a-z0-9_]+$/.test(safeErrorMessage) && (
            <Typography variant="body2" color="text.secondary">
              {safeErrorMessage}
            </Typography>
          )}
      </Box>
    </Box>
  );
};

AppErrorRendererCard.propTypes = {
  field: PropTypes.string,
  message: PropTypes.string.isRequired,
  errorMsg: PropTypes.string,
  fieldNameMap: PropTypes.objectOf(PropTypes.string),
  dataTestId: PropTypes.string,
  hasFieldErrors: PropTypes.bool,
};
